
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H22v-7a.5.5 0 00-.5-.5h-7.13l-.48-1.64a.5.5 0 00-.62-.34.5.5 0 00-.34.62l.57 1.92v6.93h-3V4.9l.07.02c.05 0 .09 0 .14-.02a.5.5 0 00.34-.62l-.57-1.92-.01-.02-.05-.09-.05-.08a.43.43 0 00-.07-.06l-.08-.06-.08-.03-.11-.02H2.5a.5.5 0 00-.5.5V23H.5c-.28 0-.5.22-.5.5s.22.5.5.5h23c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM3 23V3h6.5v20H3zm11.5 0v-6.5H21V23h-6.5z"}}),_c('path',{attrs:{"d":"M11.79 10.31l.57 1.92a.5.5 0 00.48.36c.05 0 .09 0 .14-.02a.5.5 0 00.34-.62l-.57-1.92a.5.5 0 00-.62-.34.5.5 0 00-.34.62zm-1.13-3.83l.57 1.92a.5.5 0 00.48.36c.05 0 .09 0 .14-.02a.5.5 0 00.34-.62l-.57-1.92a.5.5 0 00-.62-.34.5.5 0 00-.34.62z"}})])
          )
        }
      }
    